













































































































































































































































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCode } from '@/components/molecules/InputCode'
import { ModalTextArea } from '@/components/modals/ModalTextArea'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { IAtomSelectItem } from '@/components/atoms/AtomSelect/AtomSelect.type'

export interface CollectionMagazineManagementInfoItem {
  bibliographySetId: string // marc_noを使用しているのでstringとしている
  maxBibliographyRealId: string // marc_noを使用しているのでstringとしている
  contractYear: {
    input: string
    errorMessage: string
  }
  continuation: {
    input: string
  }
  openBookbinding: {
    input: string
  }
  bookClaim: {
    input: string
  }
  needBookbinding: {
    input: string
  }
  notArrived: {
    input: string
  }
  traderCode: {
    input: string
    errorMessage: string
  }
  donorCode: {
    input: string
    errorMessage: string
  }
  shelfPlace: {
    input: string
    errorMessage: string
  }
  memo7: {
    input: string
    errorMessage: string
  }
  holdingYear: {
    input: string
    errorMessage: string
  }
  holdingVolume: {
    input: string
    errorMessage: string
  }
  missingNumberText: {
    input: string
    errorMessage: string
  }
  memo3: {
    input: string
    errorMessage: string
  }
  memo4: {
    input: string
    errorMessage: string
  }
  memo2: {
    input: string
    errorMessage: string
  }
  retitleBefore: {
    input: string
    errorMessage: string
  }
  retitleAfter: {
    input: string
    errorMessage: string
  }
  memo1: {
    input: string
    errorMessage: string
  }
  memo6: {
    input: string
    errorMessage: string
  }
  memo5: {
    input: string
    errorMessage: string
  }
}

export const defaultCollectionMagazineManagementInfoItem = (): CollectionMagazineManagementInfoItem => ({
  bibliographySetId: '',
  maxBibliographyRealId: '',
  contractYear: {
    input: '',
    errorMessage: ''
  },
  continuation: {
    input: ''
  },
  openBookbinding: {
    input: ''
  },
  bookClaim: {
    input: ''
  },
  needBookbinding: {
    input: ''
  },
  notArrived: {
    input: ''
  },
  traderCode: {
    input: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    errorMessage: ''
  },
  shelfPlace: {
    input: '',
    errorMessage: ''
  },
  memo7: {
    input: '',
    errorMessage: ''
  },
  holdingYear: {
    input: '',
    errorMessage: ''
  },
  holdingVolume: {
    input: '',
    errorMessage: ''
  },
  missingNumberText: {
    input: '',
    errorMessage: ''
  },
  memo3: {
    input: '',
    errorMessage: ''
  },
  memo4: {
    input: '',
    errorMessage: ''
  },
  memo2: {
    input: '',
    errorMessage: ''
  },
  retitleBefore: {
    input: '',
    errorMessage: ''
  },
  retitleAfter: {
    input: '',
    errorMessage: ''
  },
  memo1: {
    input: '',
    errorMessage: ''
  },
  memo6: {
    input: '',
    errorMessage: ''
  },
  memo5: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: { InputCodeDonor, ModalTextArea, InputCode, InputCodeTrader }
})
export default class CollectionMagazineManagementInfo extends ComponentVue {
  @Ref()
  modalTextArea!: ModalTextArea

  @PropSync('input', {
    type: Object,
    required: true
  })
  item!: CollectionMagazineManagementInfoItem

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }

  get selectItems(): IAtomSelectItem[] {
    return [
      {
        value: true,
        text: '業者コード'
      },
      {
        value: false,
        text: '寄贈者コード'
      }
    ]
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  openModalTextArea(
    inputValue: { input: string; errorMessage: string },
    title: string,
    fieldName: string
  ): void {
    this.modalTextArea.open({
      value: inputValue.input,
      title,
      fieldName,
      limitLinefeed: true,
      onClickOk: (value: string) => (inputValue.input = value)
    })
  }

  @Emit('register')
  onClickRegister(): void {}
}
